import { FORM_ERROR } from "final-form";
import { useIntl } from "react-intl";

import useTrashablePromises from "hooks/useTrashablePromises";
import translateError from "utils/translateError";
import useGlobalContext from "hooks/globalData";
import {
  IResourceLibrary,
  IResourceLibraryItem,
} from "services/KnowfullyAdminClient";

import ResourceLibraryItemForm, {
  SaveResourceLibraryItemRequest,
} from "./ResourceLibraryItemForm";

type resourceLibraryItemUpdateFormProps = {
  resourceLibrary?: IResourceLibrary;
  resourceLibraryItem: IResourceLibraryItem;
  onResourceLibraryItemUpdated: () => void;
  onCancel: () => void;
};

const ResourceLibraryItemUpdateForm = ({
  resourceLibrary,
  onResourceLibraryItemUpdated,
  resourceLibraryItem,
  onCancel,
}: resourceLibraryItemUpdateFormProps) => {
  const { registerPromise } = useTrashablePromises();
  const { formatMessage: t } = useIntl();
  const { resourceLibraryService } = useGlobalContext();

  const onSubmit = (values: SaveResourceLibraryItemRequest) => {
    const {
      resourceLibraryId,
      description,
      id,
      name,
      publicationDate,
      resourceLibraryTypeId,
      sequence,
      file,
      fileName,
    } = values;
    return registerPromise(
      resourceLibraryService.saveResourceLibraryItem(
        resourceLibraryId,
        id,
        resourceLibraryTypeId,
        name,
        publicationDate,
        description,
        sequence,
        file,
        fileName
      )
    )
      .then(() => {
        onResourceLibraryItemUpdated();
      })
      .catch((err: any) => {
        console.log(err);
        return { [FORM_ERROR]: translateError(err, t) };
      });
  };

  return (
    <ResourceLibraryItemForm
      resourceLibraryItem={resourceLibraryItem}
      resourceLibrary={resourceLibrary}
      onSubmit={onSubmit}
      submitLabel={t({ id: "resourceLibraryItemFormUpdateButton" })}
      onCancel={onCancel}
    />
  );
};

export default ResourceLibraryItemUpdateForm;
